<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<div class="m-5">
    <h1 class="display-1 mb-5"
        i18n>
        Users
    </h1>
    <app-data-table-ajax columnMode="force"
                         [template]="rowDetails"
                         url="/users"
                         limit="26"
                         responseKey="users"
                         [columns]="columns"
                         [extendRow]="true"
                         (rowClicked)="onSelectRow($event)">
    </app-data-table-ajax>
</div>

<ng-template #rowDetails
             let-row="row">
    <div class="p-4">
        <app-data-table-ajax url="/users/{{row.username}}/rolescopes"
            limit="20"
            [displaySearch]="false"
            [rowHeight]="undefined"
            [columns]="userRoleColumns">
        </app-data-table-ajax>
    </div>
</ng-template>


// WEBPACK FOOTER //
// ./src/app/access-management/users/users-list/users-list.component.html